// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"61440d28","247":"b1b46849","284":"07dd194f","627":"61311799","867":"e4362608","923":"7d0e59fe","938":"404c3d86"}[chunkId] + ".chunk.js";
};